import { getAssignableUsers } from '../services/internal-support.service';
import { useQuery } from '@tanstack/react-query';
import { InternalSupportUser } from '../helpers/internal-support.types';

const useAssignableUsers = () => {
    return useQuery<InternalSupportUser[]>(['pulse-internal-assignable-users'], async () => {
        return await getAssignableUsers();
    });
};

export default useAssignableUsers;
